import React, { useState } from 'react';
import { api } from '../api';

const inp = { width: '100%', padding: '5px 8px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', height: 30 };
const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ email: '', senha: '' });
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  async function enviar(e) {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const res = await api.login(form.email, form.senha);
      onLogin(res.token, res.nome, res.cargo);
    } catch (e) {
      setErro(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a1628', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 6, padding: '28px 28px 24px', width: '100%', maxWidth: 360, boxShadow: '0 4px 24px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 22 }}>
          <img src="/logo.png" alt="Preserva Marcas e Patentes" style={{ maxWidth: 180, marginBottom: 8 }} />
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Sistema de Gestão</div>
        </div>

        <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div>
            <label style={lbl}>E-mail</label>
            <input style={inp} name="email" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="seu@email.com" required autoFocus />
          </div>
          <div>
            <label style={lbl}>Senha</label>
            <input style={inp} name="senha" type="password" value={form.senha} onChange={e => setForm(f => ({ ...f, senha: e.target.value }))} placeholder="••••••••" required />
          </div>

          {erro && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '6px 10px', borderRadius: 4, fontSize: 12 }}>
              {erro}
            </div>
          )}

          <button type="submit" disabled={loading}
            style={{ background: '#0a1628', color: '#fff', padding: '7px 0', borderRadius: 4, fontSize: 13, fontWeight: 700, border: 'none', cursor: loading ? 'default' : 'pointer', marginTop: 4, opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
